module.exports = __webpack_public_path__ + "./images/login_bg.png";